/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/nextjs-material-dashboard-pro
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

function configs(labels, datasets, chart) {
  // Calculate dynamic Y-axis scale based on data with sensible minimum
  const dataValues = datasets?.data || [];
  const maxValue = Math.max(...dataValues, 0);
  
  // If all values are zero or very small, use a smaller scale
  let suggestedMax, stepSize;
  if (maxValue === 0) {
    suggestedMax = 100;
    stepSize = 20;
  } else if (maxValue < 100) {
    suggestedMax = Math.ceil(maxValue * 1.5 / 10) * 10;
    stepSize = Math.max(10, Math.ceil(suggestedMax / 5));
  } else if (maxValue < 1000) {
    suggestedMax = Math.ceil(maxValue * 1.5 / 100) * 100;
    stepSize = Math.max(50, Math.ceil(suggestedMax / 5 / 50) * 50);
  } else if (maxValue < 10000) {
    suggestedMax = Math.ceil(maxValue * 1.2 / 1000) * 1000;
    stepSize = Math.max(500, Math.ceil(suggestedMax / 5 / 500) * 500);
  } else {
    // For large values, use fixed 10k steps
    suggestedMax = Math.ceil(maxValue * 1.2 / 10000) * 10000;
    stepSize = Math.max(10000, Math.ceil(suggestedMax / 5 / 10000) * 10000);
  }
  
  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          tension: 0,
          pointRadius: 3,
          pointBorderColor: "rgba(251, 207, 51, 1)",
          pointBackgroundColor: "rgba(251, 207, 51, 1)",
          borderColor: "rgba(251, 207, 51, 1)",
          borderWidth: 2,
          backgroundColor: "transparent",
          fill: false,
          data: datasets.data,
          maxBarThickness: 6,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            callback: function(value) {
              return 'RM ' + value.toLocaleString();
            },
            stepSize: stepSize,
          },
          beginAtZero: true,
          suggestedMax: suggestedMax,
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
            borderDash: [5, 5],
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
